import AdvanceModel from "../models/AdvanceModel";
import AdvanceRepository from "../repositories/AdvanceRepository";
import InstallmentService from "./InstallmentService";

import {
  RequiredParamException,
  ImmutableParamException,
} from "../exceptions/InvalidParamException";
import { AdvanceLinkedException } from "../exceptions/InstallmentException";

class AdvanceService {
  async createAdvance(advance: AdvanceModel): Promise<string> {
    this.validateData(advance);
    return AdvanceRepository.addAdvanceToDataBase(advance);
  }

  async deleteAdvance(advance: AdvanceModel): Promise<void> {
    if (advance.quantityLinked) {
      throw new AdvanceLinkedException();
    }

    return AdvanceRepository.deleteAdvanceFromDataBase(
      advance.contractUid,
      advance.uid
    );
  }

  async updateAdvance(
    advance: AdvanceModel,
    updatedAdvance: AdvanceModel
  ): Promise<void> {
    this.validateUpdatedData(advance, updatedAdvance);
    return AdvanceRepository.updateAdvanceOnDataBase(
      updatedAdvance.contractUid,
      updatedAdvance.uid,
      updatedAdvance
    );
  }

  async updateInstallments(advance: AdvanceModel): Promise<void> {
    const installments = advance.installments;
    return AdvanceRepository.updateAdvanceOnDataBase(
      advance.contractUid,
      advance.uid,
      { installments }
    );
  }

  async updateInstallmentsWithTransaction(
    transaction,
    advance: AdvanceModel
  ): Promise<void> {
    const installments = advance.installments;
    return AdvanceRepository.updateAdvanceOnDataBase(
      advance.contractUid,
      advance.uid,
      { installments },
      transaction
    );
  }

  subscribeAdvancesSnapshot(
    contractUid: string,
    onCreate: (data: AdvanceModel[]) => void,
    onChange: (data: AdvanceModel[]) => void,
    onRemoved: (data: AdvanceModel[]) => void
  ) {
    if (!contractUid) return;
    return AdvanceRepository.addAdvancesCollectionSnapshot(
      contractUid,
      onCreate,
      onChange,
      onRemoved
    );
  }

  validateData(advance: AdvanceModel) {
    if (!advance.title) throw new RequiredParamException("title");
    if (!advance.code) throw new RequiredParamException("code");
    if (!advance.date) throw new RequiredParamException("date");

    InstallmentService.validateData(advance);
  }

  validateUpdatedData(advance: AdvanceModel, updatedAdvance: AdvanceModel) {
    this.validateData(updatedAdvance);

    if (advance.code !== updatedAdvance.code) {
      throw new ImmutableParamException("code");
    }

    InstallmentService.validateUpdatedData(advance, updatedAdvance);
  }
}

export default new AdvanceService();
